var _excluded = ["children", "size", "square", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled, { css } from 'styled-components';
var Variants = {
  SUCCESS: 'success',
  INFO: 'info',
  NEUTRAL: 'neutral',
  ERROR: 'error'
};
var Sizes = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
var SquareHeights = {
  [Sizes.SMALL]: '18px',
  [Sizes.MEDIUM]: '30px'
};
var StyledSpan = styled.span.withConfig({
  componentId: "CL__sc-6eljgs-0"
})(["align-items:center;border-radius:var(--border-radius-small);color:var(--black);display:inline-flex;font:", ";", " background-color:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === Sizes.SMALL ? 'var(--body-text-x-small)' : 'var(--body-text-small)';
}, _ref2 => {
  var {
    size,
    square
  } = _ref2;
  return square ? css(["align-items:center;aspect-ratio:1;justify-content:center;padding:0;width:", ";"], SquareHeights[size !== null && size !== void 0 ? size : Sizes.SMALL]) : css(["padding:", ";"], size === Sizes.SMALL ? '0 var(--spacing-1)' : 'calc(var(--spacing-1) / 2) var(--spacing-2)');
}, _ref3 => {
  var {
    variant
  } = _ref3;
  if (variant === Variants.SUCCESS) return 'var(--green-1)';
  if (variant === Variants.INFO) return 'var(--blue-1)';
  if (variant === Variants.ERROR) return 'var(--red-1)';
  if (variant === Variants.NEUTRAL) return 'var(--gray-2)';
});
var Badge = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  var {
      children,
      size = Sizes.SMALL,
      square = false,
      variant = Variants.NEUTRAL
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  var hasOneLetterAndSquare = square && typeof children === 'string' && children.length === 1;
  return /*#__PURE__*/React.createElement(StyledSpan, _extends({
    ref: ref,
    size: size,
    square: hasOneLetterAndSquare,
    variant: variant
  }, props), children);
});
export default Badge;